import React from "react";
import styles from "./spinner.css";

export default function SpinnerSmall() {
  return <i className={`material-icons ${styles.spinning} grey-text`}>donut_large</i>
}